import type { ValuesOf } from '@shared/types';

export * from './data';
export * from './utils';
export * from './options';

export const ArtworksFilterKey = {
  Artists: 'artists_slugs',
  Styles: 'styles_slugs',
  Medium: 'medium_slugs',
  Countries: 'countries_slugs',
} as const;
export type ArtworksFilterKey = ValuesOf<typeof ArtworksFilterKey>;
